import React, { useEffect, useState, useRef } from "react";
import SettingTreshold from "../molecules/popup/SettingTreshold";
import { useNavigate, useParams } from "react-router-dom";
import { MQTTI } from "../../helper/mqttClient";
import { fetchApi } from "../../helper/api";
import {
  UnpackData,
  UnpackLabel,
  SensorProps,
} from "../../helper/functionSensor";
import { lightGreen, blue, purple } from "@mui/material/colors";
import { PowerDistribution } from "./PowerDistributrion";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import "chartjs-adapter-moment";
import ChartStreaming from "chartjs-plugin-streaming";
import ChartAnnotation from "chartjs-plugin-annotation";
import "chartjs-adapter-moment";
import zoomPlugin from "chartjs-plugin-zoom";
import DownloadSensor from "../molecules/popup/DownloadSensor";
import FFTGraph from "./FftGraph";
import ChartMusi from "./ChartMusi";
import { connect } from "react-redux";
import { isRoleHasAcces } from "../../helper/function";
import { engineer, superUser } from "../../helper/constantRole";
// import { param } from "jquery";

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend
// );

ChartJS.register(ChartStreaming, ChartAnnotation, zoomPlugin, ...registerables);

const RealTimeGraph = React.memo(({ sensor, PG, ipc }) => {
  let divRef = useRef({});
  const [render, setRender] = useState(true);
  const [customBenchmark, setCustomBenchmark] = useState(
    PG.map((graph) => {
      return {
        [graph.name]: {
          max: SensorProps[sensor.group].max,
          min: SensorProps[sensor.group].min,
          step: SensorProps[sensor.group].step,
        },
      };
    })
  );

  // console.log("CB", customBenchmark);
  const getOption = (indexGraph) => {
    const statement = () => {
      const splitIndex =
        sensor.group === "LVDT" || sensor.group === "Strain" ? 0 : 1;
      if (sensor.group === "Strain") {
        return "microstrain";
      } else if (sensor.group === "LVDT") {
        return "mm";
      } else {
        return PG[indexGraph].name.split(" ")[splitIndex].toLowerCase();
      }
    };

    const warningMinIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Warning Min"
    );
    const warningMinArray = sensor.sensorProps[warningMinIndex]?.values ?? [];

    const warningMinAxis =
      warningMinArray[
        warningMinArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ]?.value ?? 0;

    ///
    const warningMaxIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Warning Max"
    );
    const warningMaxArray = sensor.sensorProps[warningMaxIndex]?.values ?? [];
    const warningMaxAxis =
      warningMaxArray[
        warningMaxArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ].value ?? 0;

    ///
    const dangerMinIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Danger Min"
    );
    const dangerMinArray = sensor.sensorProps[dangerMinIndex]?.values ?? [];
    const dangerMinAxis =
      dangerMinArray[
        dangerMinArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ].value ?? 0;

    ///
    const dangerMaxIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Danger Max"
    );
    const dangerMaxArray = sensor.sensorProps[dangerMaxIndex]?.values ?? [];
    const dangerMaxAxis =
      dangerMaxArray[
        dangerMaxArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ].value ?? 0;

    let optionTreshold = {
      annotation: {
        annotations: {
          dangerMax: {
            type: "line",
            value: () => dangerMaxAxis,
            yMin: () => dangerMaxAxis,
            yMax: () => dangerMaxAxis,
            borderColor: "#d9534f",
            borderWidth: 2,
            label: {
              backgroundColor: "#d9534f67",
              backgroundShadowColor: "transparent",
              content: () => `Danger Max${dangerMaxAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
          dangerMin: {
            type: "line",
            value: () => dangerMinAxis,
            yMin: () => dangerMinAxis,
            yMax: () => dangerMinAxis,
            borderColor: "#d9534f",
            borderWidth: 2,
            label: {
              backgroundColor: "#d9534f67",
              backgroundShadowColor: "transparent",
              content: () => `Danger Min${dangerMinAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
          warningMax: {
            type: "line",
            value: () => warningMaxAxis,
            yMin: () => warningMaxAxis,
            yMax: () => warningMaxAxis,
            borderColor: "#fd9d0d",
            borderWidth: 2,
            label: {
              backgroundColor: "#fd9d0d67",
              backgroundShadowColor: "transparent",
              content: () => `Warning Max${warningMaxAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
          warningMin: {
            type: "line",
            value: () => warningMinAxis,
            yMin: () => warningMinAxis,
            yMax: () => warningMinAxis,
            borderColor: "#fd9d0d",
            borderWidth: 2,
            label: {
              backgroundColor: "#fd9d0d67",
              backgroundShadowColor: "transparent",
              content: () => `Warning Min${warningMinAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
        },
      },
    };

    return optionTreshold;
  };

  const optGraph = (graphName) => {
    const indexSensor = customBenchmark.findIndex((find) =>
      find.hasOwnProperty(graphName)
    );
    return {
      scales: {
        y: {
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value) {
              return value.toFixed(2) + SensorProps[sensor.group].satuan;
            },
          },
          // suggestedMax: SensorProps[sensor.group].max,
          // suggestedMin: SensorProps[sensor.group].min,
          // stepSize: SensorProps[sensor.group].step,
          suggestedMax: customBenchmark[indexSensor][graphName].max,
          suggestedMin: customBenchmark[indexSensor][graphName].min,
          stepSize: customBenchmark[indexSensor][graphName].step,
        },
        x: {
          type: "realtime",
          time: {
            unit: "second",
          },
          realtime: {
            duration: 10000,
            frameRate: 30,
            ttl: 12000,
            delay: 1200,
          },
        },
      },
      elements: {
        point: {
          radius: 0,
          hoverRadius: 0,
          hitRadius: 0,
        },
        line: {
          tension: 0,
        },
      },
      responsiveAnimationDuration: 0,
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      redraw: false,
    };
  };

  const CreateGraph = () => {
    let graph = PG.map((graph, index) => {
      const indexSensor = customBenchmark.findIndex((find) =>
        find.hasOwnProperty(graph.name)
      );

      const updateValue = (value, graphName, keyValue) => {
        let tempArray = customBenchmark;
        let newValue = {
          [graphName]: {
            ...tempArray[indexSensor][graphName],
            [keyValue]: value,
          },
        };
        // console.log("NEW VALUE", newValue);
        let newArray = [];
        tempArray.map((content) => {
          for (let key in content) {
            if (key !== graphName) {
              newArray.push({
                ...content,
              });
            }
          }
        });
        newArray = [...newArray, newValue];
        // console.log("NEWARRAy: ", newArray);

        setCustomBenchmark(newArray);
      };

      return (
        graph.show && (
          <div
            key={graph.name}
            className="bg-white shadow p-4 mb-4"
            style={{
              backgroundColor: "white",
              borderRadius: "10px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <div style={{ display: "flex", gap: "1em", position: "absolute" }}>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Batas Atas
                </label>
                <input
                  id="max"
                  type="number"
                  // max={null}
                  min={
                    customBenchmark[indexSensor][graph.name].min +
                    customBenchmark[indexSensor][graph.name].step
                  }
                  step={customBenchmark[indexSensor][graph.name].step}
                  value={customBenchmark[indexSensor][graph.name].max}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (
                      Number(value) >=
                      Number(customBenchmark[indexSensor][graph.name].min) +
                        Number(customBenchmark[indexSensor][graph.name].step)
                    ) {
                      updateValue(value, graph.name, "max");
                    }
                  }}
                  style={{
                    fontSize: "14px",
                    width: "100px",
                    border: "1px solid #c8c8c8",
                    borderRadius: "3px",
                    padding: "12px 15px",
                  }}
                />
              </span>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Batas Bawah
                </label>
                <input
                  id="min"
                  type="number"
                  // min={null}
                  max={
                    customBenchmark[indexSensor][graph.name].max -
                    customBenchmark[indexSensor][graph.name].step
                  }
                  step={customBenchmark[indexSensor][graph.name].step}
                  value={customBenchmark[indexSensor][graph.name].min}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (
                      Number(value) <=
                      Number(customBenchmark[indexSensor][graph.name].max) -
                        Number(customBenchmark[indexSensor][graph.name].step)
                    ) {
                      updateValue(value, graph.name, "min");
                    }
                  }}
                  style={{
                    fontSize: "14px",
                    width: "100px",
                    border: "1px solid #c8c8c8",
                    borderRadius: "3px",
                    padding: "12px 15px",
                  }}
                />
              </span>
              {/* <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Step
                </label>
                <input
                  id="step"
                  type="number"
                  min="0"
                  // max={null}
                  step={SensorProps[sensor?.group]?.step ?? "0.1"}
                  value={customBenchmark[indexSensor][graph.name].step}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (Number(value) > 0) {
                      updateValue(value, graph.name, "step");
                    }
                  }}
                  style={{
                    fontSize: "14px",
                    width: "100px",
                    border: "1px solid #c8c8c8",
                    borderRadius: "3px",
                    padding: "12px 15px",
                  }}
                />
              </span> */}
            </div>
            <Line
              ref={(ref) => (divRef.current[graph.name] = ref)}
              options={{
                ...optGraph(graph.name),
                plugins: {
                  ...getOption(index),
                  legend: {
                    title: {
                      display: true,
                      text: "",
                      padding: 17,
                    },
                  },
                },
              }}
              plugins={[
                {
                  id: "increase-legend-spacing",
                  beforeInit(chart) {
                    // Get reference to the original fit function
                    const originalFit = chart.legend.fit;
                    // Override the fit function
                    chart.legend.fit = function fit() {
                      // Call original function and bind scope in order to use `this` correctly inside it
                      originalFit.bind(chart.legend)();
                      this.height += 40;
                    };
                  },
                },
              ]}
              data={graph.data}
            />
          </div>
        )
      );
    });

    return graph;
  };

  useEffect(() => {
    if (
      sensor &&
      divRef.current !== null &&
      sensor.group !== "Power Distribution"
    ) {
      // console.log("topic", `dataStream/${ipc}/${sensor.idSensor}`);
      const instance = MQTTI().subscribe(
        `dataStream/${ipc}/${sensor.idSensor}`
      );
      // const instance = MQTTI().subscribe(`6e94fd36-a3ee-42e7-991e-74de98d9977d/custom/sensorData/${sensor.idSensor}`);
      instance.on("message", (topic, message) => {
        // const payload = { topic, message: message.toString() };
        // console.log("payload", payload);
        const raw = message.toString().split(",");
        const ts = raw[0];
        const dataToUnpack = raw[1];
        const dataSensor = UnpackData(sensor.group, dataToUnpack);
        const labelData = UnpackLabel(
          +ts,
          dataToUnpack.length / (6 * Object.keys(PG).length),
          sensor.sampleRate
        );

        // plot to grafik
        if (dataSensor != undefined) {
          PG.forEach((graph) => {
            if (divRef.current[graph.name]) {
              divRef.current[graph.name].data.datasets[0].label = graph.name;
              divRef.current[graph.name].data.labels.push(...labelData);
              divRef.current[graph.name].data.datasets[0].data.push(
                ...dataSensor[graph.name]
              );
              divRef.current[graph.name].update("quiet");
            }
          });
        }
      });
      return () => {
        setRender(false);
        instance.end();
        setTimeout(() => window.location.reload(), 100);
      };
    }
  }, []);

  return render ? <CreateGraph /> : "";
});

const SwitchGraph = React.memo(({ sensor, ipcSn, type }) => {
  switch (sensor.group) {
    case "Accelerometer":
      const accX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
            // pointRadius: 1,
            // pointHoverRadius: 5,
            // pointHitRadius: 10,
          },
        ],
      };
      const accY = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: blue["700"],
            borderColor: blue["700"],
            borderWidth: 1.5,
            hidden: false,
            // pointRadius: 1,
            // pointHoverRadius: 5,
            // pointHitRadius: 10,
          },
        ],
      };
      const accZ = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: purple["600"],
            borderColor: purple["600"],
            borderWidth: 1.5,
            hidden: false,
            // pointRadius: 1,
            // pointHoverRadius: 5,
            // pointHitRadius: 10,
          },
        ],
      };
      const accPg = [
        {
          name: `${sensor.group} X`,
          data: accX,
          show: true,
        },
        {
          name: `${sensor.group} Y`,
          data: accY,
          show: true,
        },
        {
          name: `${sensor.group} Z`,
          data: accZ,
          show: true,
        },
      ];
      if (type === "TD") {
        return <RealTimeGraph sensor={sensor} PG={accPg} ipc={ipcSn} />;
      } else if (type === "FFT") {
        return (
          <FFTGraph
            typeSensor={sensor}
            PG={accPg}
            topic={`dataStream/${ipcSn}/${sensor?.idSensor}`}
          />
        );
      }
      break;

    case "Strain":
      const strX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const strPg = [
        {
          name: `${sensor.group}`,
          data: strX,
          show: true,
        },
      ];
      if (type === "TD") {
        return <RealTimeGraph sensor={sensor} PG={strPg} ipc={ipcSn} />;
      } else if (type === "FFT") {
        return (
          <FFTGraph
            typeSensor={sensor}
            PG={strPg}
            topic={`dataStream/${ipcSn}/${sensor?.idSensor}`}
          />
        );
      }
      break;

    case "Gyroscope":
      const gyrX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: blue["700"],
            borderColor: blue["700"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const gyrY = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: blue["700"],
            borderColor: blue["700"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const gyrZ = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: purple["600"],
            borderColor: purple["600"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const gyrPg = [
        {
          name: `${sensor.group} X`,
          data: gyrX,
          show: false,
        },
        {
          name: `${sensor.group} Pitch Y`,
          data: gyrY,
          show: true,
        },
        {
          name: `${sensor.group} Roll Z`,
          data: gyrZ,
          show: true,
        },
      ];
      if (type === "TD") {
        return <RealTimeGraph sensor={sensor} PG={gyrPg} ipc={ipcSn} />;
      } else if (type === "FFT") {
        return (
          <FFTGraph
            typeSensor={sensor}
            PG={gyrPg}
            topic={`dataStream/${ipcSn}/${sensor?.idSensor}`}
          />
        );
      }
      break;

    case "LVDT":
      const lvdtX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const lvdtPg = [
        {
          name: `LVDT`,
          data: lvdtX,
          show: true,
        },
      ];
      if (type === "TD") {
        return <RealTimeGraph sensor={sensor} PG={lvdtPg} ipc={ipcSn} />;
      } else if (type === "FFT") {
        return (
          <FFTGraph
            typeSensor={sensor}
            PG={lvdtPg}
            topic={`dataStream/${ipcSn}/${sensor?.idSensor}`}
          />
        );
      }
      break;

    case "Temperature":
      const temp = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const TempPg = {
        Temperature: {
          ref: null,
          data: temp,
        },
      };
      // if (type === "TD") {
      //   return <RealTimeGraph sensor={sensor} PG={TempPg} />
      // } else if (type === "FFT") {
      //   return (
      //     <FFTGraph
      //       typeSensor={sensor}
      //       PG={TempPg}
      //       topic={`dataStream/${ipcSn}/${sensor?.idSensor}`}
      //     />
      //   );
      // }
      break;

    case "Power Distribution":
      if (type === "TD") {
        return (
          <PowerDistribution topic={`dataStream/${ipcSn}/${sensor.idSensor}`} />
        );
      }
      break;

    default:
      return <>Sensor is not detected...</>;
  }
});

const ChhartMonitor = (props) => {
  const params = useParams();
  const [sensor, setSensor] = useState();
  const [isLoad, setIsLoad] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const req = await fetchApi(`api/Rtu/sensor/${params.id}`, "GET", true);
    const res = await req.json();
    if (req.status !== 404) {
      res.data.idSensor = params.id;
      setSensor(res.data);
    }
    setIsLoad(false);
  };
  const updateTreshold = () => {
    getData();
  };
  const fixDataStatic = (sensorPush) => {
    if (params.ipc.includes("IPCC")) {
      sensorPush.group = "Accelerometer";
    }
    return sensorPush;
  };

  return (
    <>
      {isLoad && <>Loading ...</>}
      {sensor ? (
        <div className="p-4">
          <DownloadSensor data={sensor} />
          <SettingTreshold callback={updateTreshold} data={sensor} />
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <span
                onClick={() => window.history.back()}
                className="mr-2"
                style={{ cursor: "pointer" }}
              >
                <i
                  className="las la-arrow-left"
                  style={{ fontSize: "30px" }}
                ></i>
              </span>
              <div>
                <h1 className="mb-0">
                  Monitor {sensor.group} {sensor.numberSensor}
                </h1>
                <p>Serial Number : {sensor.idSensor}</p>
              </div>
            </div>
            {!params.ipc.includes("IPCC") && (
              <div className="d-flex align-items-center">
                {isRoleHasAcces(
                  [engineer, superUser],
                  props._dataProfile.role
                ) && (
                  <button
                    data-toggle="modal"
                    data-target="#SettingTreshold_modal"
                    className="btn btn-info ml-3 d-flex align-items-center"
                  >
                    <i
                      className="las la-sliders-h"
                      style={{ fontSize: "30px" }}
                    ></i>
                    Setting Threshold
                  </button>
                )}
                {sensor.group !== "Power Distribution" && (
                  <button
                    className="btn btn-warning ml-3 d-flex align-items-center"
                    onClick={() => {
                      navigate("/playback-data", {
                        state: {
                          idSensor: params?.id,
                          group: sensor.group,
                          numberSensor: sensor?.numberSensor,
                        },
                      });
                    }}
                  >
                    <i
                      className="las la-chart-area mr-2"
                      style={{ fontSize: 24 }}
                    ></i>
                    Playback Data
                  </button>
                )}
                {/* <button
                  className="btn btn-success ml-3 d-flex align-items-center"
                  data-toggle="modal"
                  data-target="#download_sensor_modal"
                >
                  <i className="las la-save mr-2" style={{ fontSize: 24 }}></i>
                  Download Report
                </button> */}
              </div>
            )}
          </div>
          {!params.ipc.includes("IPCC") && sensor.group === "Accelerometer" && (
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  id="home-tab"
                  data-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  Time Domain
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  FFT
                </a>
              </li>
            </ul>
          )}
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="row w-100">
                {params.ipc.includes("IPCC") ? (
                  <ChartMusi sensor={params.id} ipc={params.ipc} />
                ) : (
                  <SwitchGraph
                    sensor={fixDataStatic(sensor)}
                    ipcSn={params.ipc}
                    type="TD"
                  />
                )}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              {sensor.group === "Accelerometer" && (
                <SwitchGraph
                  sensor={fixDataStatic(sensor)}
                  ipcSn={params.ipc}
                  type="FFT"
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="p-4">
          <p className="text-center">Sensor tidak tersedia</p>
        </div>
      )}
    </>
  );
};
const mapState = (state) => {
  return {
    _dataProfile: state.dataProfile,
  };
};
export default connect(mapState)(ChhartMonitor);
